import React from "react";
import {
  FaUserTie,
  FaUserGraduate,
  FaUniversity,
  FaAward,
} from "react-icons/fa";

const members = [
  {
    name: "Prof. A. Lal M.D.",
    role: "PATRON",
    icon: <FaAward />,
    details: [
      "Principal (Retd.)",
      "S.T. Medical College, Haldwani, U.K.",
      "Professor & Head (Rtd.)",
      "Institute of Medical Sciences",
      "B.H.U., Varanasi (U.P.)",
    ],
  },
  {
    name: "Prof. J.P. Lal Ph.D.",
    role: "HONORABLE DIRECTOR",
    icon: <FaUniversity />,
    details: [
      "Professor-cum-Scientist",
      "Institute of Agricultural Sciences",
      "Banaras Hindu University",
      "Varanasi (U.P.)",
    ],
  },
  {
    name: "Dr. D.K. Srivastava",
    role: "EXEC. DIRECTOR",
    icon: <FaUserGraduate />,
    details: ["M.Sc., Ph.D."],
  },
  {
    name: "Smt. Vijaya Srivastava",
    role: "MANAGER – TRUSTEE",
    icon: <FaUserTie />,
    details: ["M.A., B.Ed."],
  },
  {
    name: "Mr. S.K. Srivastava",
    role: "TRUSTEE",
    icon: <FaUserTie />,
    details: ["M.D., Steel Sol. India"],
  },
  {
    name: "Smt. Sangeeta Srivastava",
    role: "TRUSTEE",
    icon: <FaUserGraduate />,
    details: ["M.A. (English)"],
  },
];

const Administration = () => {
  return (
    <section className="relative py-16 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-300/20 rounded-full blur-3xl -translate-x-20"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-red-300/20 rounded-full blur-3xl translate-x-20"></div>

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-5 py-2 text-sm font-semibold text-red-600 bg-red-100 rounded-full mb-4">
            Leadership Team
          </span>

          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            School{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Administration
            </span>
          </h2>

          <p className="text-gray-600 mt-4 max-w-2xl mx-auto leading-7">
            Dedicated administrators and trustees guiding the school with
            vision, values and academic excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-7">
          {members.map((member, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-[30px] p-6 shadow-xl border border-orange-100 overflow-hidden hover:-translate-y-2 hover:shadow-2xl transition-all duration-500"
            >
              <div className="absolute top-0 right-0 w-28 h-28 bg-gradient-to-br from-red-100 to-orange-100 rounded-bl-full"></div>

              <div className="relative">
                <div className="flex items-start justify-between gap-4 mb-6">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-red-600 to-orange-500 text-white flex items-center justify-center text-2xl shadow-lg group-hover:rotate-6 transition duration-500">
                    {member.icon}
                  </div>

                  <span className="px-3 py-1 text-[11px] font-bold text-red-600 bg-red-100 rounded-full">
                    {member.role}
                  </span>
                </div>

                <h3 className="text-xl font-extrabold text-gray-900 mb-4">
                  {member.name}
                </h3>

                <div className="space-y-2">
                  {member.details.map((line, i) => (
                    <p
                      key={i}
                      className="text-sm text-gray-600 leading-6 border-l-2 border-orange-300 pl-3"
                    >
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-white rounded-[28px] shadow-lg border border-orange-100 p-6 text-center">
          <p className="text-gray-600 leading-7 max-w-3xl mx-auto">
            Our administration works with commitment to build a disciplined,
            value-based and progressive learning environment for every student.
          </p>
        </div>
      </div>
    </section>
  );
};
export default Administration;